<script lang="ts">
    import { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import {
        faCamera,
        faCloudUploadAlt,
        faTrashAlt,
        faSearch,
        faEdit,
        faLink,
        faPhoneSquare,
        faPencilAlt,
        faFileSignature,
        faHistory,
        faUsers,
        faLayerGroup,
        faCalendarCheck,
        faShoppingCart,
        faSearchDollar,
        faCaretDown,
        faCreditCard,
        faCoins,
        faHome,
    } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import PersonTabPos from './person-tab-pos.svelte'
    import PersonTabSchedule from './person-tab-schedule.svelte'
    import PersonTabEvent from './person-tab-event.svelte'
    import PersonEdit from './person-edit.svelte'
    import Popover from '../_common/popover.svelte'
    import PersonTabNotes from './person-tab-notes.svelte'
    import PersonTabProspect from './person-tab-prospect.svelte'
    import PersonTabAudience from './person-tab-audience.svelte'
    import PersonTabForm from './person-tab-form.svelte'
    import { faWhatsappSquare } from '@fortawesome/free-brands-svg-icons'
    import PersonsProfileLink from './persons-profile-link.svelte'
    import PersonTabBalanceV2 from './person-tab-balance-v2.svelte'
    import PersonTabZandupay from './person-tab-zandupay.svelte'
    import PersonTabFinancial from './person-tab-financial.svelte'
    import PersonTabHome from './person-tab-home.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZinputGroup from '../_common/z/zinput-group.svelte'
    import Ztouch from '../_common/z/ztouch.svelte'
    import { createEventDispatcher, tick } from 'svelte'
    import Zdrop from '../_common/z/zdrop.svelte'
    import type { ZdropInterface } from '../_common/z/zdrop.interface'
    import ImagePic from '../_common/ImagePic.svelte'
    import CustomerBalanceEntries from '../customer-balance/customer-balance-entries.svelte'

    const dispatch = createEventDispatcher()

    const compound = [
        'Joao Miguel',
        'Joao Pedro',
        'Pedro Henrique',
        'Enzo Gabriel',
        'Davi Lucca',
        'Joao Lucas',
        'Joao Gabriel',
        'Davi Lucas',
        'Joao Guilherme',
        'Arthur Miguel',
        'Anthony Gabriel',
        'Luiz Miguel',
        'Joao Vitor',
        'Joao Victor',
        'Arthur Gabriel',
        'Luiz Felipe',
        'Davi Miguel',
        'Pedro Lucas',
        'Jose Miguel',
        'Pedro Miguel',
        'Vitor Hugo',
        'Victor Hugo',
        'Maria Luisa',
        'Maria Lucia',
        'Maria Alice',
        'Maria Julia',
        'Maria Clara',
        'Maria Cecilia',
        'Maria Helena',
        'Maria Eduarda',
        'Ana Clara',
        'Ana Julia',
        'Ana Luisa',
        'Ana Laura',
        'Ana Liz',
        'Ana Maria',
        'Maria Vitoria',
        'Maria Liz',
        'Ana Beatriz',
        'Maria Fernanda',
        'Maria Valentina',
        'Maria Laura',
        'Maria Isis',
        'Ana Cecilia',
        'Maria do Carmo',
        'Maria Aparecida',
    ]
    const pronouns = [
        'Dr',
        'Dr.',
        'Drª',
        'Dra',
        'Dra.',
        'Espaco',
        'Clinica',
        'Studio',
        'Estetica',
        'Consultorio',
        'Ana',
        'Anna',
        'Seu',
        'Instituto',
        'Biomedica',
        'Biomedico',
        'Doutor',
        'Doutora',
        'Fisioterapeuta',
        'Esteticista',
        'Senhor',
        'Senhora',
    ]

    export let params: { act?: 'search' | 'new' | 'show'; query: string; tab?: number }

    let localParams = null
    let person: Person = null
    const isMobile = screen.width <= 900
    const isIOS = window.api.utils.utils.isIOS()

    let recents: boolean = false
    async function loadRecents() {
        recents = true
        let found: string[] = await window.flags('person-recents', true)
        if (!found || found.length === 0) return
        persons = await personS.getAll({ persons: found })
        persons.sort((x, y) => found.indexOf(y.personId) - found.indexOf(x.personId))
    }

    $: {
        evaluateParamsChange(params)
    }

    async function evaluateParamsChange(_params) {
        localParams = Object.assign({}, _params)
        search = false
        persons = []
        person = null

        if (!localParams || localParams.act == 'search') {
            console.log('search', localParams.query)
            search = true
            if (localParams.query) {
                goSearch(query)
            } else {
                setTimeout(() => inputQuery.focus())
                loadRecents()
            }
            return
        }

        if (localParams?.act == 'new') {
            newPerson()
            return
        }

        if (localParams?.query) {
            loadPerson(localParams.query, localParams.tab || tab || 1)
            return
        }
    }

    let firstName = ''
    let lastName = ''
    let tab = 11
    async function loadPerson(query, _tab) {
        if (!query) return
        // se não é um GUID inicia uma busca
        if (query.length !== 36 || query.split('-') === 5) {
            console.log('redir-to-search', query)
            search = true
            inputQuery = query
            await goSearch(query)
            return
        }
        person = await personS.getOne(query)
        firstName = getFirstName(person.name)
        lastName = getLastName(person.name)
        query = ''
        persons = []
        search = false
        let tempTab = _tab
        tab = 0
        //await personS.update(person.personId, { requestedAt: new Date() })
        addToRecents(person.personId)
        setTimeout(() => (tab = tempTab), 100)
    }

    async function addToRecents(personId: string) {
        let found: string[] = await window.flags('person-recents', true)
        if (!found) found = []
        const exists = found.findIndex((f) => f === personId)
        if (exists >= 0) found.splice(exists, 1)
        if (found.length >= 5) found.shift()
        found.push(personId)
        await window.flags('person-recents', true, found)
    }

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }
    function getFirstName(name: string) {
        const parts = name?.split(' ')
        if (parts.length <= 1) return parts[0]

        if (compound.includes(normalize(parts[0]) + ' ' + normalize(parts[1]))) {
            return parts[0] + ' ' + parts[1]
        }

        if (pronouns.includes(normalize(parts[0]))) {
            return parts[0] + ' ' + parts[1]
        }

        return parts[0]
    }

    function getLastName(name: string) {
        return name.replace(getFirstName(name), '')
    }

    const personR = new PersonsRepository()
    const personS = new PersonsService(personR)
    let query = ''
    let persons: Person[] = []
    let inputQuery
    let message = ''
    let delay = null
    let loading = false

    async function goSearch(_query: string) {
        if (_query?.length === 0) {
            loadRecents()
        }

        if (_query?.length < 3) {
            persons = []
            message = ''
            return
        }
        message = ''
        loading = true
        if (delay) clearInterval(delay)
        delay = setTimeout(async () => {
            persons = await personS.search(query, 30)
            recents = false
            message = persons.length === 0 ? 'Nenhuma pessoa encontrada' : ''
            loading = false
        }, 500)
    }

    let search = false
    $: {
        goSearch(query)
        if (search) {
            showSearch()
        }
    }

    function showSearch() {
        if (localParams.act == 'search') return
        evaluateParamsChange({ act: 'search' })
    }

    function select(index) {
        evaluateParamsChange({ act: 'show', query: persons[index].personId })
    }

    let _showEdit = false
    function showEdit() {
        _showEdit = true
    }

    let _showLink = false
    function showLink() {
        _showLink = true
    }

    async function hideEdit(event) {
        _showEdit = false
        if (!event.detail) {
            dispatch('close')
            return
        }
        if (search && event.detail?.personId) {
            query = event.detail.phone
        }
        if (event.detail) person = event.detail
        firstName = getFirstName(person.name)
        lastName = getLastName(person.name)
    }

    function newPerson() {
        person = new Person()
        firstName = ''
        lastName = ''
        showEdit()
    }

    function onRemoved() {
        _showEdit = false
        showSearch()
    }

    function openWA(phone) {
        if (window.api.utils.utils.isMobile()) {
            window.open('https://wa.me/' + phone)
        } else {
            window.open('https://web.whatsapp.com/send/?phone=' + phone + '&text&type=phone_number&app_absent=0', 'znd_wa')
            //window.message({ personId: person.personId })
        }
    }

    function openPhone(phone) {
        if (window.api.utils.utils.isMobile()) {
            window.location.href = 'tel:' + phone
        } else {
            window.location.href = 'zandu-tel:' + phone
        }
    }

    let hideMenu = true
    function goTab(_tab: number) {
        hideMenu = !hideMenu
        tab = _tab
    }

    let imageMenu: ZdropInterface = {
        position: 'top-left',
        positionMargin: '4px',
        format: 'circle',
        icon: faCamera,
        buttons: [
            {
                callback: imageMenuUpload,
                icon: faCloudUploadAlt,
                label: 'Alterar...',
            },
            {
                callback: imageMenuRemove,
                icon: faTrashAlt,
                label: 'Remover',
            },
        ],
    }

    async function imageMenuRemove() {
        if (!confirm('Deseja realmente remover a imagem?')) return
        await personS.update(person.personId, { image: '' })
        person.image = ''
    }

    let showImagePic = false
    let image = null
    let imagePicClick
    async function imageMenuUpload() {
        image = person.image
        showImagePic = true
        await tick()
        imagePicClick()
    }

    async function imageMenuUploadOnChange(ev) {
        if (!ev.detail?.base64) return
        await personS.update(person.personId, { image: ev.detail.base64 })
        person.image = ev.detail.base64
        person = person
        showImagePic = false
    }
</script>

{#if showImagePic}
    <Popover title="Imagem de Perfil" width="260px" on:close={() => (showImagePic = false)}>
        <div class="p-3">
            <ImagePic
                bind:click={imagePicClick}
                upload={true}
                base64={person.image}
                on:change={imageMenuUploadOnChange}
                on:cancel={() => (showImagePic = false)}
            ></ImagePic>
        </div>
    </Popover>
{/if}
{#if _showLink}
    <Popover title="Agenda Online" width="1200px" height="155px" on:close={() => (_showLink = false)}>
        <PersonsProfileLink personId={person.personId} />
    </Popover>
{/if}

{#if _showEdit}
    <Popover on:close={hideEdit} title="Pessoa" height="480px" width="970px">
        <PersonEdit on:close={hideEdit} {person} on:removed={onRemoved} />
    </Popover>
{/if}

{#if window.store?.token?.permissions?.super || window.store?.token?.permissions?.persons?.show}
    <div class="root-person">
        {#if search}
            <div class="search p-4">
                <div class="label">Pesquisar nome ou telefone</div>
                <div class="input-group">
                    <input bind:this={inputQuery} type="text" bind:value={query} class="form-control" />
                </div>
                <div class="results">
                    {#if loading}
                        <div class="spinner_outer">
                            <div class="spinner"></div>
                        </div>
                    {:else}
                        {#if persons.length > 0}
                            <div class="results_title">
                                {#if recents}
                                    Pessoas acessadas recentemente:
                                {:else}
                                    Resultados da busca:
                                {/if}
                            </div>
                        {/if}
                        {#each persons as p, i}
                            <a class="result" on:click={() => select(i)}>
                                <div class="pic">
                                    {#if p.image}
                                        <img src={p.image} alt="" />
                                    {/if}
                                </div>
                                <div class="content">
                                    <div class="name">{p.name}{p.businessName ? ' / ' + p.businessName : ''}</div>
                                    <div class="info">
                                        Celular: {window.api.utils.utils.phoneFriendly(p.phone)}{!!p.email ? ' | E-Mail: ' + p.email : ''}{!!p.document
                                            ? ' | Documento: ' + p.document
                                            : ''}
                                    </div>
                                </div>
                            </a>
                        {/each}
                        {#if message}
                            <div class="text-muted text-center">{message}</div>
                        {/if}
                    {/if}
                </div>
                {#if window.store.token.permissions.persons.persons.write}
                    <button on:click={newPerson} class="btn btn-secondary new">Cadastrar uma pessoa</button>
                {/if}
            </div>
        {/if}
        {#if !search && person}
            <div class="profile">
                <button class="btn-search" on:click={showSearch}><Fa icon={faSearch} /><span class="h-mobile">&nbsp;&nbsp;Buscar</span></button>
                <div class="profile-head-outer" style={isMobile && !isIOS ? "background-image:url('" + person.image + "');" : ''}>
                    <div class="profile-head" class:removed={person.status !== 100}>
                        <div class="head-pic">
                            {#if person.image}
                                <img src={person.image} alt="" />
                            {:else}
                                <div />
                            {/if}
                            <div class="head-pic_shift">
                                <Zdrop menu={imageMenu}></Zdrop>
                            </div>
                        </div>
                        <div class="head-content">
                            <div class="info">
                                <div class="info-name">
                                    <div class="first-name">{firstName}</div>
                                    {#if person.status !== 100}
                                        <div class="person-removed">Esta pessoa foi excluída</div>
                                    {/if}
                                </div>
                                <div class="info-line h-mobile">
                                    <div class="title-badge">Nome</div>
                                    <div class="title-content">
                                        {person.name}{person.businessName ? ' / ' + person.businessName : ''}
                                    </div>
                                </div>
                                {#if person.status === 100}
                                    <div class="info-line h-mobile">
                                        <div class="title-badge">Telefone</div>
                                        <div class="title-content">
                                            {window.api.utils.utils.phoneFriendly(person.phone)}
                                        </div>
                                        <div class="title-badge">E-mail</div>
                                        <div class="title-content">{person.email || '-'}</div>
                                    </div>
                                {/if}
                            </div>
                            <div class="info-act">
                                {#if isMobile}
                                    <Ztouch class="touch-color" on:click={showEdit} icon={faEdit} label="Editar"></Ztouch>
                                    <Ztouch class="touch-color" on:click={showLink} icon={faLink} label="Link de agendamento"></Ztouch>
                                    <Ztouch class="touch-color" on:click={() => openPhone(person.phone)} icon={faPhoneSquare} label="Ligar"></Ztouch>
                                    <Ztouch class="touch-color" on:click={() => openWA(person.phone)} icon={faWhatsappSquare} label="Enviar mensagem"></Ztouch>
                                {:else}
                                    <ZinputGroup>
                                        <Zbutton on:click={showEdit} icon={faEdit} label="Editar"></Zbutton>
                                        <Zbutton on:click={showLink} icon={faLink} label="Link de agendamento"></Zbutton>
                                        <Zbutton on:click={() => openWA(person.phone)} icon={faWhatsappSquare} label="Enviar mensagem"></Zbutton>
                                    </ZinputGroup>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile-body">
                    <div class="profile-body-menu">
                        <div class="btns">
                            {#if window.store.token.permissions.persons.show}
                                <button on:click={() => goTab(11)} class="btn" class:hide-menu={hideMenu} class:active={tab === 11}
                                    ><span><Fa icon={faHome} /></span>Início</button
                                >
                            {/if}

                            {#if window.store.token.permissions.persons.tabs.notes}
                                <button on:click={() => goTab(4)} class="btn" class:hide-menu={hideMenu} class:active={tab === 4}
                                    ><span><Fa icon={faPencilAlt} /></span>Notas</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.prospect && window.featureFlags.includes('prospect')}
                                <button on:click={() => goTab(5)} class="btn" class:hide-menu={hideMenu} class:active={tab === 5}
                                    ><span><Fa icon={faSearchDollar} /></span>Prospecção</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.pos}
                                <button on:click={() => goTab(1)} class="btn" class:hide-menu={hideMenu} class:active={tab === 1}
                                    ><span><Fa icon={faShoppingCart} /></span>PDV / Compras</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.zanduPay}
                                <button on:click={() => goTab(9)} class="btn" class:hide-menu={hideMenu} class:active={tab === 9}
                                    ><span><Fa icon={faCreditCard} /></span>ZanduPay</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.zanduPay}
                                <button on:click={() => goTab(10)} class="btn" class:hide-menu={hideMenu} class:active={tab === 10}
                                    ><span><Fa icon={faCoins} /></span>Financeiro</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.forms}
                                <button on:click={() => goTab(7)} class="btn" class:hide-menu={hideMenu} class:active={tab === 7}
                                    ><span><Fa icon={faFileSignature} /></span>Atendimento</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.scheduler}
                                <button on:click={() => goTab(2)} class="btn" class:hide-menu={hideMenu} class:active={tab === 2}
                                    ><span><Fa icon={faCalendarCheck} /></span>Agenda</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.balance}
                                <button on:click={() => goTab(8)} class="btn" class:hide-menu={hideMenu} class:active={tab === 8}
                                    ><span><Fa icon={faLayerGroup} /></span>Saldo de serviços</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.audience}
                                <button on:click={() => goTab(6)} class="btn h-mobile" class:hide-menu={hideMenu} class:active={tab === 6}
                                    ><span><Fa icon={faUsers} /></span>Públicos</button
                                >
                            {/if}
                            {#if window.store.token.permissions.persons.tabs.events}
                                <button on:click={() => goTab(3)} class="btn h-mobile" class:hide-menu={hideMenu} class:active={tab === 3}
                                    ><span><Fa icon={faHistory} /></span>Eventos</button
                                >
                            {/if}
                        </div>
                        <div class="btns-show h-full" on:click={() => goTab(tab)}>
                            <Fa icon={faCaretDown}></Fa>
                        </div>
                    </div>
                    <div class="profile-body-content">
                        {#if tab === 0}
                            <div class="text-muted mt-2 text-center">Carregando...</div>
                        {/if}
                        {#if tab === 1 && window.store.token.permissions.persons.tabs.pos}
                            <PersonTabPos personId={person.personId} />
                        {/if}
                        {#if tab === 2}
                            <PersonTabSchedule personId={person.personId} />
                        {/if}
                        {#if tab === 3}
                            <PersonTabEvent personId={person.personId} />
                        {/if}
                        {#if tab === 4}
                            <PersonTabNotes personId={person.personId} />
                        {/if}
                        {#if tab === 5}
                            <PersonTabProspect businessId={person.businessId} />
                        {/if}
                        {#if tab === 6}
                            <PersonTabAudience personId={person.personId} />
                        {/if}
                        {#if tab === 7}
                            <PersonTabForm personId={person.personId} />
                        {/if}
                        {#if tab === 8}
                            <!-- <PersonTabBalanceV2 personId={person.personId} /> -->
                            <CustomerBalanceEntries personId={person.personId}></CustomerBalanceEntries>
                        {/if}
                        {#if tab === 9}
                            <PersonTabZandupay personId={person.personId}></PersonTabZandupay>
                        {/if}
                        {#if tab === 10}
                            <PersonTabFinancial personId={person.personId}></PersonTabFinancial>
                        {/if}
                        {#if tab === 11}
                            <PersonTabHome {person}></PersonTabHome>
                        {/if}
                    </div>
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .removed {
        font-style: italic;
    }
    .removed .-edit {
        display: none;
    }
    .root-person {
        flex-grow: 1;
    }
    .root-person .label {
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        margin-bottom: 8px;
    }
    .root-person .search {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .root-person .new {
        margin-top: 48px;
    }

    .search .results {
        padding-top: 8px;
        width: 100%;
    }
    .search .result {
        padding: 4px;
        border: 0px;
        background: #99999915;
        width: 100%;
        cursor: pointer;
        text-align: left;
        display: inline-block;
    }
    .search .result:not(:last-child) {
        border-bottom: 1px solid #99999930;
    }
    .search .result .name {
        font-size: 18px;
        white-space: nowrap;
        overflow: hidden;
    }
    .search .result .info {
        opacity: 0.7;
        white-space: nowrap;
        overflow: hidden;
    }
    .profile {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        position: relative;
        min-height: 100%;
        flex-grow: 1;
    }
    /* .zgrid é global e tem height:100%. como .profile-body-content é um flex item esticado (altura
       definida), cada grid da aba tentava ocupar a altura inteira — com dois ou mais grids empilhados
       o total passava do espaço disponível e o excedente era cortado pelo overflow:hidden do .profile,
       sem que a rolagem do popover chegasse ao final. nas abas do perfil os grids têm altura natural
       e quem rola é o popover. */
    .profile-body-content :global(.zgrid) {
        height: auto;
    }
    .profile-head {
        display: flex;
        flex-shrink: 0;
        align-items: stretch;
        margin-top: 0px;
    }
    .profile-head .head-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
    .profile-head .head-pic {
        font-size: 30px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;
        border-radius: 8px;
        flex: 0 0 160px;
        background-color: #00000060;
        height: 160px;
        position: relative;
    }

    .head-pic img {
        max-width: 100%;
    }
    .profile-head .info {
        white-space: nowrap;
        overflow: hidden;
        padding-top: 6px;
    }
    .profile-head .info-name {
        white-space: nowrap;
        overflow: hidden;
    }
    .head-content .first-name {
        opacity: 0.8;
        font-size: 48px;
        line-height: 100%;
    }
    .head-content .info-line {
        display: flex;
        margin-top: 4px;
    }
    .head-content .info-line .title-content {
        margin-right: 12px;
    }

    .profile .btn-search {
        border-radius: 4px;
        margin-top: 4px;
        border-right: 1px solid #99999935;
        width: 110px;
        position: absolute;
        background-color: #00000030;
        right: 45px;
        color: #aaa;
        border: 1px;
        width: 95px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 1;
    }

    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .results .spinner_outer {
        text-align: center;
        padding: 16px;
    }
    .results .spinner:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        width: 40px;
        height: 40px;
        margin-left: -20px;
        border-radius: 50%;
        border: 5px solid #fff;
        border-top-color: #1565c0;
        animation: spinner 0.6s linear infinite;
    }

    @media (max-width: 900px) {
        .head-content .first-name {
            font-size: 30px;
            margin-bottom: 6px;
        }
        .head-pic_shift {
            display: none;
        }
        .profile .btn-search {
            right: 8px;
            width: 45px;
        }
    }
</style>
